import React from "react";
import PropTypes from "prop-types";
import styles from "./TicketItem.module.css";

/**
 * View component. Displays info about a ticket.
 */
export function TicketItem({ ticketInfo }) {
  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItem}>{ticketInfo.event}</div>
      <div className={styles.gridItem}>{ticketInfo.jobCode}</div>
      <div className={styles.gridItem}>{ticketInfo.name}</div>
      <div className={styles.gridItem}>{ticketInfo.id}</div>
      <div className={styles.gridItem}>{ticketInfo.date}</div>
    </div>
  );
}

TicketItem.propTypes = {
  /**
   * Object with the tickets info.
   */
  ticketInfo: PropTypes.shape({
    event: PropTypes.string,
    jobCode: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    date: PropTypes.string,
  }),
};
